import { NAVBAR_HEIGHT } from '@constants/index';

export function scrollToSection(id: string): void {
  const element = document.getElementById(id);
  if (!element) return;
  const top = element.getBoundingClientRect().top + window.scrollY - NAVBAR_HEIGHT;
  window.scrollTo({ top, behavior: 'smooth' });
}

export function scrollToAnchor(href: string): void {
  const id = href.replace('#', '');
  scrollToSection(id);
}

/**
 * Scrolls to an anchor that may not exist yet.
 *
 * Nav links point at home-page sections, but the visitor may be on another
 * route when they click one. Routing home mounts a lazily-loaded page, so the
 * target can be several frames away — poll for it instead of guessing a delay,
 * and give up rather than spin if the section never appears.
 */
export function scrollToAnchorWhenReady(href: string, timeoutMs = 2000): void {
  const id = href.replace('#', '');
  const deadline = performance.now() + timeoutMs;

  const attempt = () => {
    if (document.getElementById(id)) {
      scrollToSection(id);
      return;
    }
    if (performance.now() < deadline) requestAnimationFrame(attempt);
  };

  requestAnimationFrame(attempt);
}